import React, { useRef } from 'react';

import { Box } from '@rover/kibble/core';

import useDirectionalSticky from '../hooks/useDirectionalSticky';
import { StickySidebarContext } from '../hooks/useStickySidebar';

import RevampServicesCta, { CTADatesProps, CTAProps } from './RevampServicesCta';

const DESKTOP_ONLY_DISPLAY = ['none', 'none', 'block'];
const STICKY_TOP_OFFSET = 0;
const STICKY_BOTTOM_GAP = 16;

type Props = CTAProps & CTADatesProps;

const RevampStickySidebar = (ctaProps: Props): JSX.Element => {
  const sidebarRef = useRef<HTMLDivElement>(null);
  const { stickyTop, controls } = useDirectionalSticky(sidebarRef, {
    topOffset: STICKY_TOP_OFFSET,
    bottomGap: STICKY_BOTTOM_GAP,
  });

  return (
    <Box
      ref={sidebarRef}
      display={DESKTOP_ONLY_DISPLAY}
      width="352px"
      flexShrink="0"
      position="sticky"
      top={stickyTop}
      zIndex="1"
      alignSelf="flex-start"
      pb="10x"
      mt="6x"
      order={1}
    >
      <StickySidebarContext.Provider value={controls}>
        <RevampServicesCta {...ctaProps} />
      </StickySidebarContext.Provider>
    </Box>
  );
};

export default RevampStickySidebar;
